import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  // Center of current LonLat
  geoPositionCenter: [0, 0],
  // Center of map, when user moved the map manually via mouse or touch
  temporaryCenterOfManuallyMovedMap: [0, 0],
  // Center View and follow recording, initially true
  lockViewToCenter: true,
  // Current Geolocation (for immediate display on screen)
  // (The saved route is managed in "newActivity/saveTmpCoords")
  currentGeolocation: {
    accuracy: 0,
    altitude: 0,
    altitudeAccuracy: 0,
    heading: 0,
    lat: 0,
    lon: 0,
    speed: 0,
    currentDistance: 0
  },
  // Geolocation initial data
  // TODO: with reverse GeoIP => address, currentl ynot in use, but keep it!
  startGeoLocData: {
    lat: 0,
    lon: 0,
    accuracy: null,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null,
    latFixedFloat: 0,
    lonFixedFloat: 0,
    plz: null,
    city: null,
    district: null,
    label: null,
    houseNumber: null,
    neighbourhood: null,
    county: null,
    country: null,
    state: null,
    additionalData: null
  },
  zoomInDuration: 750
}

export default {
  state,
  mutations,
  actions,
  getters
}
